/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModel } from '../../models/user-model';

export interface UserGet$Plain$Params {
}

export function userGet$Plain(http: HttpClient, rootUrl: string, params?: UserGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModel>> {
  const rb = new RequestBuilder(rootUrl, userGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<UserModel>;
    })
  );
}

userGet$Plain.PATH = '/User';
